/**
 * Central API configuration. Values come from .env (REACT_APP_*).
 */
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://localhost:7193';
const API_URL = `${BASE_URL}/api`;

/** Normalize list from API: backend may return [] or { $values: [] } (ReferenceHandler.Preserve). */
function normalizeList(data) {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.$values)) return data.$values;
  return [];
}

/** Data URI for image onError fallback - avoids re-requesting a broken URL (stops 404 loop). */
const BROKEN_IMAGE_PLACEHOLDER =
  'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>');

/** True if URL origin is a local dev host (stored in DB when admin uploaded from localhost). */
function isLocalDevImageOrigin(urlString) {
  try {
    const u = new URL(urlString);
    const h = u.hostname.toLowerCase();
    return h === 'localhost' || h === '127.0.0.1' || h === '[::1]';
  } catch {
    return false;
  }
}

/**
 * Build full URL for database-driven image paths.
 * Handles: null/empty (return fallback), full http(s) URL (return as-is unless localhost origin → use BASE_URL + path),
 * /path (BASE_URL + path), path (BASE_URL + / + path).
 */
/** Store API-relative paths in DB (e.g. /uploads/...) — avoids broken URLs when BASE_URL changes. */
function normalizeStorageUrl(url) {
  if (url == null || String(url).trim() === '') return '';
  const s = String(url).trim();
  if (s.startsWith('http://') || s.startsWith('https://')) {
    try {
      const u = new URL(s);
      return `${u.pathname}${u.search}${u.hash}`;
    } catch {
      return s;
    }
  }
  return s.startsWith('/') ? s : `/${s}`;
}

function getImageUrl(url, fallback = BROKEN_IMAGE_PLACEHOLDER) {
  if (url == null || String(url).trim() === '') return fallback;
  const s = String(url).trim();
  if (s.startsWith('http://') || s.startsWith('https://')) {
    if (isLocalDevImageOrigin(s)) {
      try {
        const u = new URL(s);
        const path = `${u.pathname}${u.search}${u.hash}`;
        return path.startsWith('/') ? `${BASE_URL}${path}` : `${BASE_URL}/${path}`;
      } catch {
        return s;
      }
    }
    return s;
  }
  if (s.startsWith('/')) return `${BASE_URL}${s}`;
  return `${BASE_URL}/${s}`;
}

export { BASE_URL, API_URL, BROKEN_IMAGE_PLACEHOLDER, getImageUrl, normalizeList, normalizeStorageUrl };
